import React, { Component } from 'react';
import '../styles/App.css';
import axios from 'axios';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ApiConfig from '../config'

import exit from '../assets/icons/white/exit.png';
import hamburger from '../assets/icons/white/hamburger.png';
import search from '../assets/icons/white/search.png';
import loader from '../assets/loader.gif';

import FranchiseDash from './FranchiseDash';
import FranchiseCallModal from './FranchiseCallModal';

let currentRecordState = [];
let revertState = [];
let dataIndex = [];

export default class FranchiseSales extends Component {
  constructor(props) {
    super();
    this.state = {
      loading: true,
      error: "",
      data: null,
      dataURL: 'https://api.airtable.com/v0/',
      tampaId: 'appBsaVxz2OicG5Zw',
      orlandoId: 'appLxxBrc9m3yNXdQ',
      loadingText: 'Finding Pre-Meeting Followups',

      openedCall: {},

      tampaOffset: '',
      orlandoOffset: '',

      theFollows: {
        newLeads: [],
        preFirst: [],
        preMid: [],
        preOngoing: [],
        preOld: [],
        postNext: [],
        postFirst: [],
        postMid: [],
        postOngoing: [],
        postOld: [],
      },

      thisList: [],
      meetings: [],
      todays: [],
      planned: [],

      modalType: '',
      modal: false,
    }
  }



  loadOrlandoDashboard = () => {
    let loadOrlandoPreFirst = function() {
      console.log('loadOrlandoPreFirst');
      let grabRecords = this.state.theFollows.preFirst;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+First';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }

          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPreFirst();
        } else {
          console.log('clearing loadOrlandoPreFirst()');

          let theCalls = this.state.theFollows;
          theCalls.preFirst = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoPreMid();
          }).bind(this), 50);
        }
      });
    }.bind(this);
    loadOrlandoPreFirst();

    let loadOrlandoPreMid = function() {
      console.log('loadOrlandoPreMid');
      let grabRecords = this.state.theFollows.preMid;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+Mid';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPreMid();
        } else {
          console.log('clearing loadOrlandoPreMid()');

          let theCalls = this.state.theFollows;
          theCalls.preMid = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoPreOngoing();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoPreOngoing = function() {
      console.log('loadOrlandoPreOngoing');
      let grabRecords = this.state.theFollows.preOngoing;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+Ongoing';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPreOngoing();
        } else {
          console.log('clearing loadOrlandoPreOngoing()');

          let theCalls = this.state.theFollows;
          theCalls.preOngoing = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoPreOld();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoPreOld = function() {
      console.log('loadOrlandoPreOld');
      let grabRecords = this.state.theFollows.preOld;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+Old';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPreOld();
        } else {
          console.log('clearing loadOrlandoPreOld()');

          let theCalls = this.state.theFollows;
          theCalls.preOld = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
              loadingText: 'Finding Post-Meeting Followups',
            });
            loadOrlandoPostFirst();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoPostFirst = function() {
      console.log('loadOrlandoPostFirst');
      let grabRecords = this.state.theFollows.postFirst;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+First';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPostFirst();
        } else {
          console.log('clearing loadOrlandoPostFirst()');

          let theCalls = this.state.theFollows;
          theCalls.postFirst = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoNextDay();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoNextDay = function() {
      console.log('loadOrlandoNextDay');
      let grabRecords = this.state.theFollows.postNext;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Next+Day';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          console.log(response.data.records);
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoNextDay();
        } else {
          console.log('clearing loadOrlandoNextDay()');

          let theCalls = this.state.theFollows;
          theCalls.postNext = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoPostMid();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoPostMid = function() {
      console.log('loadOrlandoPostMid');
      let grabRecords = this.state.theFollows.postMid;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Mid';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPostMid();
        } else {
          console.log('clearing loadOrlandoPostMid()');

          let theCalls = this.state.theFollows;
          theCalls.postMid = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoPostOngoing();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoPostOngoing = function() {
      console.log('loadOrlandoPostOngoing');
      let grabRecords = this.state.theFollows.postOngoing;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Ongoing';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPostOngoing();
        } else {
          console.log('clearing loadOrlandoPostOngoing()');

          let theCalls = this.state.theFollows;
          theCalls.postOngoing = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadOrlandoPostOld();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadOrlandoPostOld = function() {
      console.log('loadOrlandoPostOld');
      let grabRecords = this.state.theFollows.postOld;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Old';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadOrlandoPostOld();
        } else {
          console.log('clearing loadOrlandoPostOld()');

          let theCalls = this.state.theFollows;
          theCalls.postOld = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            finishFollows();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let finishFollows = function() {
      console.log(this.state.theFollows);

      this.setState({
        loadingText: 'Finding Meetings',
      })
      orlandoMeetings();

    }.bind(this);

    let orlandoMeetings = function() {
      console.log('orlandoMeetings');
      let grabRecords = this.state.meetings;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Meetings';
      if (this.state.orlandoOffset !== '') {customersURL = customersURL + '&offset=' + this.state.orlandoOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'orlando';
          }
          this.setState({
            meetings: grabRecords.concat(response.data.records),
            error: false,
            orlandoOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          orlandoMeetings();
        } else {
          console.log('clearing orlandoMeetings()');

          this.setState({
            orlandoOffset: '',
          });
          finishMeetings();
        }
      });
    }.bind(this);


    let finishMeetings = function() {
      console.log(this.state.meetings);
      let meetingList = this.state.meetings;

      meetingList.sort(function(a,b){
        return new Date(b.fields['Appt. Date']) - new Date(a.fields['Appt. Date']);
      });


      this.setState({
        meetings: meetingList,
      });

      orlandoRecent();
    }.bind(this);

    let orlandoRecent = function() {
      console.log('orlandoRecent');
      let grabRecords = this.state.todays;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.orlandoId + '/' + 'Franchisees' + '?view=Recent+Calls';
      if (this.state.orlandoOffset !== '') {customersURL = customersURL + '&offset=' + this.state.orlandoOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          this.setState({
            todays: grabRecords.concat(response.data.records),
            error: false,
            orlandoOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          orlandoRecent();
        } else {
          console.log('clearing orlandoRecent()');

          this.setState({
            orlandoOffset: '',
            loading: false,
          });
        }
      });
    }.bind(this);
  }














  loadTampaDashboard = () => {
    let loadTampaPreFirst = function() {
      console.log('loadTampaPreFirst');
      let grabRecords = this.state.theFollows.preFirst;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+First';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          console.log(response.data.records);

          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }

          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPreFirst();
        } else {
          console.log('clearing loadTampaPreFirst()');

          let theCalls = this.state.theFollows;
          theCalls.preFirst = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPreMid();
          }).bind(this), 50);
        }
      });
    }.bind(this);
    loadTampaPreFirst();

    let loadTampaPreMid = function() {
      console.log('loadTampaPreMid');
      let grabRecords = this.state.theFollows.preMid;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+Mid';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }

          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPreMid();
        } else {
          console.log('clearing loadTampaPreMid()');

          let theCalls = this.state.theFollows;
          theCalls.preMid = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPreOngoing();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadTampaPreOngoing = function() {
      console.log('loadTampaPreOngoing');
      let grabRecords = this.state.theFollows.preOngoing;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+Ongoing';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPreOngoing();
        } else {
          console.log('clearing loadTampaPreOngoing()');

          let theCalls = this.state.theFollows;
          theCalls.preOngoing = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPreOld();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadTampaPreOld = function() {
      console.log('loadTampaPreOld');
      let grabRecords = this.state.theFollows.preOld;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Pre+Old';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPreOld();
        } else {
          console.log('clearing loadTampaPreOld()');

          let theCalls = this.state.theFollows;
          theCalls.preOld = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPostFirst();
          }).bind(this), 50);
        }
      });
    }.bind(this);



    let loadTampaPostFirst = function() {
      console.log('loadTampaPostFirst');
      let grabRecords = this.state.theFollows.postFirst;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+First';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          console.log(response.data.records);
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPostFirst();
        } else {
          console.log('clearing loadTampaPostFirst()');

          let theCalls = this.state.theFollows;
          theCalls.postFirst = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaNextDay();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadTampaNextDay = function() {
      console.log('loadTampaNextDay');
      let grabRecords = this.state.theFollows.postNext;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Next+Day';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          console.log(response.data.records);
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaNextDay();
        } else {
          console.log('clearing loadTampaNextDay()');

          let theCalls = this.state.theFollows;
          theCalls.postNext = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPostMid();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadTampaPostMid = function() {
      console.log('loadTampaPostMid');
      let grabRecords = this.state.theFollows.postMid;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Mid';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPostMid();
        } else {
          console.log('clearing loadTampaPostMid()');

          let theCalls = this.state.theFollows;
          theCalls.postMid = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPostOngoing();
          }).bind(this), 50);
        }
      });
    }.bind(this);


    let loadTampaPostOngoing = function() {
      console.log('loadTampaPostOngoing');
      let grabRecords = this.state.theFollows.postOngoing;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Ongoing';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPostOngoing();
        } else {
          console.log('clearing loadTampaPostOngoing()');

          let theCalls = this.state.theFollows;
          theCalls.postOngoing = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            loadTampaPostOld();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let loadTampaPostOld = function() {
      console.log('loadTampaPostOld');
      let grabRecords = this.state.theFollows.postOld;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Follow+Ups+Post+Old';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          this.setState({
            thisList: grabRecords.concat(response.data.records),
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          loadTampaPostOld();
        } else {
          console.log('clearing loadTampaPostOld()');

          let theCalls = this.state.theFollows;
          theCalls.postOld = this.state.thisList;

          this.setState({
            theFollows: theCalls,
            tampaOffset: '',
          });

          setTimeout((function() {
            this.setState({
              thisList: [],
            });
            finishFollows();
          }).bind(this), 50);
        }
      });
    }.bind(this);

    let finishFollows = function() {
      console.log(this.state.theFollows);

      this.setState({
        loadingText: 'Finding Meetings',
      })

      tampaMeetings();
    }.bind(this);





    let tampaMeetings = function() {
      console.log('tampaMeetings');
      let grabRecords = this.state.meetings;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Meetings';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          for (var i in response.data.records) {
            response.data.records[i].region = 'tampa';
          }
          this.setState({
            meetings: grabRecords.concat(response.data.records),
            error: false,
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          tampaMeetings();
        } else {
          console.log('clearing tampaMeetings()');

          this.setState({
            tampaOffset: '',
          });
          finishMeetings();
        }
      });
    }.bind(this);


    let finishMeetings = function() {
      console.log(this.state.meetings);
      let meetingList = this.state.meetings;

      meetingList.sort(function(a,b){
        return new Date(b.fields['Appt. Date']) - new Date(a.fields['Appt. Date']);
      });


      this.setState({
        meetings: meetingList,
      });

      tampaRecent();
    }.bind(this);



    let tampaRecent = function() {
      console.log('tampaRecent');
      let grabRecords = this.state.todays;

      let customersURL = 'https://api.airtable.com/v0/' + this.state.tampaId + '/' + 'Franchisees' + '?view=Recent+Calls';
      if (this.state.tampaOffset !== '') {customersURL = customersURL + '&offset=' + this.state.tampaOffset;}

      axios.get(customersURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
          this.setState({
            todays: grabRecords.concat(response.data.records),
            error: false,
            tampaOffset: response.data.offset,
          });
        if (response.data.offset !== undefined) {
          tampaRecent();
        } else {
          console.log('clearing tampaRecent()');

          this.setState({
            tampaOffset: '',
            loading: false,
          });
        }
      });
    }.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem('isLogged')  !== 'true') {
      this.props.history.push('/login');
    } else {
      let twoWeeksAgo = new Date(+new Date - 1000*60*60*24*14);
      if (localStorage.getItem('lastLogin')) { //logged in after update
        let lastLog = new Date(localStorage.getItem('lastLogin'));
        if (lastLog > twoWeeksAgo) { //logged in within past two weeks
          if (localStorage.getItem('isOutside')  === 'true') {
            if (localStorage.getItem('userOffice') !== 'both' && localStorage.getItem('userRole') !== 'all') {
              if (this.props.citySet !== localStorage.getItem('userOffice')) {
                this.props.history.push('/outside/' + localStorage.getItem('userOffice') + '/');
              }
            } else {
              this.props.history.push('/outside/' + this.props.citySet);
            }
          }

          if (this.props.citySet === 'tampa') {
            this.loadTampaDashboard();
          } else if (this.props.citySet === 'orlando') {
            this.loadOrlandoDashboard();
          }
        } else {
          sessionStorage.clear();
          localStorage.clear();
        }
      } else {
        sessionStorage.clear();
        localStorage.clear();
        this.props.history.push('/login');
      }
    }
  }

  changeRecordHandler = e => {
    currentRecordState = this.state.openedCall;

    console.log(e.target.value);
    if (e.target.id === 'customCallback') {
      if (e.callBackDate) {
        currentRecordState.fields['Callback Date'] = e.callBackDate
      } else {currentRecordState.fields['Callback Date'] = undefined;}
    } else if (e.target.id === 'callBack') {
      if (e.target.value === ''){
        currentRecordState.fields['Callback Date'] = undefined;
      } else {
        currentRecordState.fields['Callback Date'] = e.target.value;
      }
    } else if (e.target.id === 'apptSet') {currentRecordState.fields['Appt. Set Date'] = e.target.value}
    else if (e.target.id === 'apptDate') {currentRecordState.fields['Appt. Date'] = e.target.value}
    else if (e.target.id === 'apptTime') {currentRecordState.fields['Appt. Time'] = e.target.value}
    else if (e.target.id === 'proposal') {currentRecordState.fields['Proposal Date'] = e.target.value}

    else if (e.target.id === 'salutation') {currentRecordState.fields['Salutation'] = e.target.value}
    else if (e.target.id === 'contact') {currentRecordState.fields['Main contact'] = e.target.value}
    else if (e.target.id === 'title') {currentRecordState.fields['Title'] = e.target.value}
    else if (e.target.id === 'altContact') {currentRecordState.fields['Alternate Contact'] = e.target.value}
    else if (e.target.id === 'phone') {currentRecordState.fields['Office Phone'] = e.target.value}
    else if (e.target.id === 'ext') {currentRecordState.fields['Extension'] = e.target.value}
    else if (e.target.id === 'cell') {currentRecordState.fields['Cell Phone'] = e.target.value}
    else if (e.target.id === 'email') {currentRecordState.fields['Email'] = e.target.value}

    else if (e.target.id === 'addr1') {currentRecordState.fields['Address 1'] = e.target.value}
    else if (e.target.id === 'addr2') {currentRecordState.fields['Address 2'] = e.target.value}
    else if (e.target.id === 'city') {currentRecordState.fields['City'] = e.target.value}
    else if (e.target.id === 'zip') {currentRecordState.fields['Zip'] = e.target.value}
    else if (e.target.id === 'county') {currentRecordState.fields['County'] = e.target.value}
    else if (e.target.id === 'emp') {currentRecordState.fields['Employees'] = e.target.value}

    else if (e.target.id === 'amount') {currentRecordState.fields['Monthly Amount'] = e.target.value}
    else if (e.target.id === 'sqFt') {currentRecordState.fields['Sq. Footage'] = e.target.value}
    else if (e.target.id === 'sqFtReal') {currentRecordState.fields['Actual Sq Footage'] = e.target.value}
    else if (e.target.id === 'restrooms') {currentRecordState.fields['Restrooms'] = e.target.value}

    else if (e.target.id === 'hoursPer') {currentRecordState.fields['Hours Per'] = e.target.value}
    else if (e.target.id === 'sqFtPer') {currentRecordState.fields['SQ Ft. per Hour'] = e.target.value}
    else if (e.target.id === 'timesPerWeek') {currentRecordState.fields['Times per Week'] = e.target.value}
    else if (e.target.id === 'weekDays') {currentRecordState.fields['Days of Week'] = e.target.value}
    else if (e.target.id === 'serviceTime') {currentRecordState.fields['Service Time'] = e.target.value}

    this.setState({
      openedCall: currentRecordState,
      recordChanges: true,
    })
  }
  selectChange = e => {
    let currentsRec = this.state.openedCall;

    if (e.target.id === 'timesPerWeekSelect') {
      currentsRec.fields['Times per Week'] = e.target.value;
    } else if (e.target.id === 'setBySelect') {
      currentsRec.fields['Appt. Set By'] = e.target.value;
    } else if (e.target.id === 'standingSelect') {
      currentsRec.fields['Standing'] = e.target.value;
    } else if (e.target.id === 'repSelect') {
      currentsRec.fields['Sales Rep'] = e.target.value;
    }
    this.setState({
      openedCall: currentsRec,
    });
  }

  showModal = (e, type, region) => {
    if (type === 'meeting--No' || type === 'meeting--Yes') {
      this.setState({
        modal: true,
        modalType: type,
        openedCall: e,
      });
    } else {
      let followUpURL = 'https://api.airtable.com/v0/appNqtJO2EtRRk9vj/Franchise';
      axios.get(followUpURL, {headers: {
        "Authorization": 'Bearer ' + ApiConfig()
      }}).then(response => {
        let resItems = response.data.records;

        this.setState({
          modal: true,
          modalType: type,
          openedCall: e,
          followUpList: resItems,
          currentFollowUp: resItems[Math.floor(Math.random()*resItems.length)]
        });
      });
    }
  }


  closeModal = () => {
    this.setState({
      modal: false,
      modalType: '',
      openedCall: {},
    })
  }


  hideDayPicker = () => {
    let getTheBlock = document.getElementById(this.state.pickerId).closest('.inputWithTag').previousElementSibling.previousElementSibling;
    getTheBlock.className = 'pickWrapper';
    this.setState({
      pickerId: null,
    })
  }
  handleDayClick = day => {
    currentRecordState = this.state.openedCall;
    let newSelectedDay = new Date(day);
    let finalDate = (newSelectedDay.getMonth() + 1) + '/' + newSelectedDay.getDate() + '/' + newSelectedDay.getFullYear();


    if (this.state.pickerId === 'closed') {currentRecordState.fields['Close Date'] = finalDate}
    else if (this.state.pickerId === 'walkthrough') {currentRecordState.fields['Walkthrough Date'] = finalDate}
    else if (this.state.pickerId === 'start') {currentRecordState.fields['Start Date'] = finalDate}
    else if (this.state.pickerId === 'cancel') {currentRecordState.fields['Cancel Date'] = finalDate}
    else if (this.state.pickerId === 'preCleanDate') {currentRecordState.fields['Pre-Clean Date'] = finalDate}
    else if (this.state.pickerId === 'apptSet') {currentRecordState.fields['Appt. Set Date'] = finalDate}
    else if (this.state.pickerId === 'apptDate') {currentRecordState.fields['Appt. Date'] = finalDate}
    else if (this.state.pickerId === 'proposal') {currentRecordState.fields['Proposal Date'] = finalDate}
    else if (this.state.pickerId === 'callDate') {currentRecordState.fields['Recent Call Date'] = finalDate}
    else if (this.state.pickerId === 'callBack') {currentRecordState.fields['Callback Date'] = finalDate}
    else if (this.state.pickerId === 'followDate') {currentRecordState.fields['Last Contact'] = finalDate}

    this.setState({
      openedCall: currentRecordState,
      recordChanges: true,
    })

    setTimeout((function() {
      console.log('yooo');
      this.hideDayPicker();
    }).bind(this), 50);
  }
  toggleDayPicker = e => {
    let dayID = e.target.closest('.inputWithTag').getElementsByTagName('input')[0].id;
    let cardParent = e.target.closest('.inputWithTag').closest('.inputBlock').closest('.callColumn');
    let pickerBlock = e.target.closest('.inputWithTag').previousElementSibling.previousElementSibling;

    if (pickerBlock.className === 'pickWrapper isActive' || pickerBlock.className === 'pickWrapper isActive cardOnRight') {
      this.hideDayPicker();
    } else {
      if (this.state.pickerId != null) {
        this.hideDayPicker();
      }
      setTimeout((function() {
        if (cardParent) {
          if (cardParent.style.left !== '0px') {
            pickerBlock.className = 'pickWrapper isActive cardOnRight';
          } else {
            pickerBlock.className = 'pickWrapper isActive';
          }
        } else new Promise(function(resolve, reject) {
          pickerBlock.className = 'pickWrapper isActive';
        });
        this.setState({
          pickerId: dayID,
        })
      }).bind(this), 50);
    }
  }

  logCall = (e, i) => {
    console.log(e);
    console.log(i);
    let currRec = this.state.openedCall;

    if (i === 'setAppt' || i === 'noVisit') {
      currRec.fields['Appt. Set By'] = e['Appt. Set By'];
      currRec.fields['Appt. Set Date'] = e['Appt. Set Date'];
      currRec.fields['Status'] = e['Status'];
      currRec.fields['Proposal Type'] = e['Proposal Type'];
    }
    currRec.fields['Recent Call Date'] = e['Recent Call Date'];
    currRec.fields['Recent Caller'] = e['Recent Caller'];
    currRec.fields['Notes'] = e['Notes'];
    currRec.fields['Recent Call Time'] = e['Recent Call Time']

    console.log(currRec);

    this.setState({
      openedCall: currRec,
    })

    if (i === 'setAppt' || i === 'noVisit') {
      this.setState({
        calendarNote: e['calNote']
      });

      setTimeout((function() {
        this.googleCalLink();
      }).bind(this), 100);
    } else {
      setTimeout((function() {
        this.saveRecordHandler('reload');
      }).bind(this), 100);
    }
  }


  saveRecordHandler = e => {
    console.log('saveRecordHandler()');

    let pushRecordId = this.state.openedCall.id;
    let finalPush = {"fields": this.state.openedCall.fields}

    let regionId;
    if (this.state.itemRegion === 'tampa') {
      regionId = this.state.tampaId;
    } else {
      regionId = this.state.orlandoId;
    }
    axios
    .put(this.state.dataURL + regionId + '/Sales/' + pushRecordId, finalPush)
    .then(response => {
      if (e === 'reload') {
        window.location.reload();
      }
    });
  }


  render() {
    const { loading, error, data } = this.state;

    if (loading) {
      return (
        <div className="modal">
          <div className="LoadModal modalInner">
            <div className="modalTitle">
              <img src={loader} alt="" />
              <h4>{this.state.loadingText}</h4>
            </div>
          </div>
        </div>
      )
    }
    if (error) {
      return (
        <p>
          There was an error loading the data.{" "}
          <button onClick={this.loadData}>Try again</button>
        </p>
      );
    }

    return (
      <div className="FranchiseDashboard">
        {this.modalShow}
        <FranchiseDash
          theFollows={this.state.theFollows}
          meetings={this.state.meetings}
          planned={this.state.planned}
          todays={this.state.todays}
          showModal={this.showModal}
        />
      </div>
    );
  }

  get modalShow() {
    if (this.state.modal) {
      if (this.state.modalType === 'call') {
        return (
          <FranchiseCallModal
            openedCall={this.state.openedCall}
            closeModal={this.closeModal}
            followUpList={this.state.followUpList}
            currentFollowUp={this.state.currentFollowUp}
          />
        );
      } else if (this.state.modalType === 'meeting--No' || this.state.modalType === 'meeting--Yes') {
        return (
          <FranchiseCallModal
            openedCall={this.state.openedCall}
            closeModal={this.closeModal}
            answer={this.state.modalType}
          />
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Franchisees/FranchiseDashboard.js